module.exports = __webpack_public_path__ + "static/media/redCircles.b7ff1e3b.svg";